import { BarcodeScanModalBase } from '@components/BarCodeScanModal/Modals/BarcodeScanModalBase'
import { BarcodeScanModalProps } from '@components/BarCodeScanModal/types'
import { PrimaryButton } from '@components/core/Button'
import { getCustomizableBrand } from '@libs/custom'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSendPolarizedSameSizeMocoAnalyticsEvent } from './analytics'

export const BarcodeScanModalUnavailablePolarizedSameMoco = ({
  visible,
  onCancel,
  productInfo,
}: BarcodeScanModalProps) => {
  const { t } = useTranslation()
  const { originalBrandCode, thumbnails, customizable } = productInfo
  const formattedBrand = getCustomizableBrand(originalBrandCode)

  const subtitle = t('BarCodeScanModal.StandardSameModelSubtitle')
  const title = t('BarCodeScanModal.StandardSameModelTitle')
  const description = t('BarCodeScanModal.StandardDescriptionSameModel')
  const { sendCloseModalEvent } = useSendPolarizedSameSizeMocoAnalyticsEvent(visible)

  const handleOnCancel = useCallback(() => {
    sendCloseModalEvent()
    onCancel()
  }, [onCancel, sendCloseModalEvent])

  return (
    <BarcodeScanModalBase
      visible={visible}
      title={title}
      titleWeight="bold"
      subtitle={subtitle}
      description={description}
      customizable={customizable}
      formattedBrand={formattedBrand}
      thumbnails={thumbnails}
      onCancel={handleOnCancel}
      footerContent={[
        <PrimaryButton fullWidth key="cancel" onClick={handleOnCancel}>
          {t('BarCodeScanModal.showBtnStandard')}
        </PrimaryButton>,
      ]}
    />
  )
}
